import { defineStore } from "pinia";

class BaseSingletonEntity {
  /** ******************* Private Static Vars *********************/
  static #instancesByClass = {};
  static #internalCall = false;

  /** ******************* Private Instance Vars *********************/
  #stores = [];

  /** ******************* Public Methods *********************/
  _initializeStore() {
    if (!BaseSingletonEntity.#internalCall) {
      throw new Error(`${this.constructor.name}._initializeStore() is internal and cannot be called directly.`);
    }
    throw new Error(`${this.constructor.name} must implement _initializeStore()`);
  }

  _defineStore(storeKey, options) {
    const storeOptions = typeof options === "function" ? { state: options } : options;
    const store = defineStore(storeKey, storeOptions)();
    this.#stores.push(store);
    return store;
  }

  async clearCache() {
    this.#stores.forEach(store => store.$reset());
  }

  /** ******************* Protected Static Methods *********************/
  static _getInstance(SubClass, instanceKey, factory) {
    if (!BaseSingletonEntity.#instancesByClass[instanceKey]) {
      BaseSingletonEntity.#instancesByClass[instanceKey] = factory();
    }
    return BaseSingletonEntity.#instancesByClass[instanceKey];
  }

  static _callInitializeStore(instance) {
    BaseSingletonEntity.#internalCall = true;
    instance._initializeStore();
    BaseSingletonEntity.#internalCall = false;
  }
}

export default BaseSingletonEntity;
